import React from "react";
import FileIcon from "src/img/notice/document.svg";
import svgRemove from "src/img/chatBubbleActionIcons/remove_attachment.svg";
import svgAttach from "src/img/chatBubbleActionIcons/attachments.svg";
import svgCancel from "src/img/chatBubbleActionIcons/cancel_action.svg";

const attachmentRowStyle = {
    alignItems: "center",
    background: "var(--calendar-surface, #fff)",
    border: "1px solid var(--calendar-border, #DBE5ED)",
    borderRadius: "6px",
    boxSizing: "border-box",
    display: "flex",
    marginBottom: "8px",
    minWidth: 0,
    padding: "12px",
    width: "100%"
};

const attachmentLabelStyle = {
    alignItems: "center",
    color: "#001191",
    display: "flex",
    flex: "0 0 auto",
    fontFamily: "Manrope, Helvetica, sans-serif",
    fontSize: "0.75rem",
    gap: "0.4rem",
    margin: "0 1rem"
};

const previewListStyle = {
    display: "flex",
    flex: "1 1 auto",
    gap: "1rem",
    minWidth: 0,
    overflowX: "auto"
};

const previewItemStyle = {
    alignItems: "center",
    display: "flex",
    flex: "0 0 auto",
    height: "65px",
    position: "relative"
};

const previewImageStyle = {
    borderRadius: "10px",
    height: "65px",
    objectFit: "cover",
    width: "101px"
};

const removeButtonStyle = {
    background: "var(--calendar-surface, #fff)",
    border: 0,
    borderRadius: "50%",
    cursor: "pointer",
    height: "28px",
    padding: 0,
    position: "absolute",
    right: "1px",
    top: "1px",
    width: "28px"
};

const filePreviewStyle = {
    alignItems: "center",
    background: "var(--calendar-surface-tertiary, #EEF2F7)",
    borderRadius: "10px",
    color: "var(--calendar-text, #171A22)",
    display: "flex",
    fontSize: "0.85rem",
    gap: "0.4rem",
    height: "50px",
    maxWidth: "12rem",
    overflow: "hidden",
    padding: "0 0.75rem",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
};

export const AttachmentContainer = ({ attachments, onRemove }) => {
    if (!attachments || attachments.length === 0) {
        return null;
    }

    return (
        <div style={attachmentRowStyle}>
            <div style={attachmentLabelStyle}>
                <img src={svgAttach} alt="" width="15" height="14" />
                Attachments
            </div>
            <div style={previewListStyle}>
                {attachments.map((file, index) => (
                    <div key={`${file.name}-${index}`} style={previewItemStyle}>
                        {file.url && file.type.startsWith("image/") ? (
                            <img src={file.url} alt={file.name} style={previewImageStyle} />
                        ) : file.url && file.type.startsWith("video/") ? (
                            <img src={file.url} alt={file.name} style={previewImageStyle} />
                        ) : (
                            <div style={filePreviewStyle}>
                                <img src={FileIcon} alt="" width="18" height="18" />
                                {file.name}
                            </div>
                        )}
                        <button type="button" onClick={() => onRemove(index)} style={removeButtonStyle} aria-label={`Remove ${file.name}`}>
                            <img src={svgRemove} alt="" width="28" height="28" />
                        </button>
                    </div>
                ))}
            </div>
            <button type="button" onClick={() => onRemove(-1)} style={{ ...removeButtonStyle, flex: "0 0 auto", marginLeft: "1rem", position: "static" }} aria-label="Remove all attachments">
                <img src={svgCancel} alt="" width="28" height="28" />
            </button>
        </div>
    );
};
